"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toArray_1 = __importDefault(require("lodash/toArray"));
var json_1 = require("../helpers/json");
var queryString_1 = require("../helpers/queryString");
var moment_1 = __importDefault(require("moment"));
var UsersModel = /** @class */ (function () {
    function UsersModel($http, UserService, APPURL) {
        this.$http = $http;
        this.UserService = UserService;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: this.APPURL + '/api/v1/users',
            UPDATE: this.APPURL + '/api/v1/users',
            CREATE: this.APPURL + '/api/v1/users'
        };
        this.cacheResponse = this.cacheResponse.bind(this);
        this.cacheUsers = this.cacheUsers.bind(this);
        this.cacheSingleUser = this.cacheSingleUser.bind(this);
        this.cacheUser = this.cacheUser.bind(this);
        this.extract = this.extract.bind(this);
    }
    UsersModel.prototype.extract = function (result) {
        return result.data;
    };
    UsersModel.prototype.cacheUsers = function (result) {
        var users = this.extract(result);
        if (users.hasOwnProperty('students')) {
            if (users.students.hasOwnProperty('data')) {
                users.students.data.forEach(function (user) {
                    var metadata = {};
                    user.usermeta.forEach(function (meta) {
                        metadata[meta.meta_key] = (0, json_1.isJson)(meta.meta_value) ? JSON.parse(meta.meta_value) : meta.meta_value;
                    });
                    user.usermeta = metadata;
                });
                users.students.data = (0, toArray_1.default)(users.students.data);
                return users;
            }
            if (typeof users.students === 'object') {
                users.students = (0, toArray_1.default)(users.students);
            }
        }
        if (users.instructors && typeof users.instructors === 'object') {
            if (users.instructors.hasOwnProperty('data')) {
                users.instructors.data = (0, toArray_1.default)(users.instructors.data);
                return users;
            }
            users.instructors = (0, toArray_1.default)(users.instructors);
        }
        return users;
    };
    UsersModel.prototype.cacheSingleUser = function (result) {
        //if( !this.currentUser ) {
        //    this.currentUser = extract(result);
        //}
        var users = this.extract(result);
        return users;
    };
    UsersModel.prototype.cacheUser = function (result) {
        var user = this.extract(result).user;
        var metadata = {};
        user.usermeta.forEach(function (meta) {
            metadata[meta.meta_key] = (0, json_1.isJson)(meta.meta_value) ? JSON.parse(meta.meta_value) : meta.meta_value;
        });
        if (typeof user.school !== 'undefined') {
            var policies_1 = {};
            user.school.policies.forEach(function (policy) {
                var policymeta = {};
                policies_1[policy.name] = {
                    policymeta: {}
                };
                policy.policymeta.forEach(function (meta) {
                    policymeta[meta.meta_key] = meta.meta_value;
                });
                policies_1[policy.name].policymeta = policymeta;
            });
            // @ts-ignore
            user.school.policies = policies_1;
        }
        // TODO: Store/update entire user object?
        // Update current user status in memory if the current user is the user being fetched
        var currentUser = this.UserService.getCurrentUser();
        if (currentUser.id === user.id && currentUser.status !== user.status) {
            this.UserService.getCurrentUser().status = user.status;
        }
        /* @ts-ignore */
        user.usermeta = metadata;
        /* @ts-ignore */
        return user;
    };
    UsersModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    /**
     * User specific model data (admins, owners)
     */
    UsersModel.prototype.getUserByID = function (userId) {
        return this.$http.get(this.URLS.FETCH + '/' + userId).then(this.cacheSingleUser);
    };
    UsersModel.prototype.searchUsers = function (data) {
        return this.$http.get(this.URLS.CREATE + '/search?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
    };
    UsersModel.prototype.createUser = function (user) {
        return this.$http.post(this.URLS.CREATE, user).then(this.cacheUsers);
    };
    UsersModel.prototype.updateUser = function (user) {
        return this.$http.put(this.URLS.FETCH + '/' + user.id, user).then(this.cacheUsers);
    };
    UsersModel.prototype.deleteUser = function (user) {
        return this.$http.delete(this.URLS.FETCH + '/' + user.id).then(this.cacheUsers);
    };
    /**
     * Instructor specific model data
     */
    UsersModel.prototype.getInstructorByID = function (id) {
        return this.$http.get(this.URLS.FETCH + '/instructors/' + id).then(this.cacheUser);
    };
    UsersModel.prototype.getInstructorSchedule = function (id, data) {
        if (data === void 0) { data = null; }
        if (data) {
            var url = this.URLS.FETCH + '/instructors/' + id + '/schedule?' + (0, queryString_1.toQueryString)(data);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors/' + id + '/schedule').then(this.cacheUsers);
    };
    UsersModel.prototype.printInstructorSchedule = function (id, data) {
        if (data === void 0) { data = null; }
        if (data) {
            var url = this.URLS.FETCH + '/instructors/' + id + '/schedule/print?' + (0, queryString_1.toQueryString)(data);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors/' + id + '/schedule/print').then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorDrives = function (data) {
        if (data) {
            var url = this.URLS.FETCH + '/instructors/' + data.id + '/drives?' + (0, queryString_1.toQueryString)(data);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors/' + data.id + 'drives').then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorPendingReportCards = function (id, params) {
        if (params === void 0) { params = null; }
        if (params !== null) {
            var url = this.URLS.FETCH + '/instructors/' + id + '/pending-reportcards?' + (0, queryString_1.toQueryString)(params);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors/' + id + '/pending-reportcards').then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorsUpcomingStudents = function (data) {
        if (data) {
            var url = this.URLS.FETCH + '/instructors/' + data.id + '/upcoming/students?' + (0, queryString_1.toQueryString)(data);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors/' + data.id + '/upcoming/students').then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructors = function (data) {
        if (data && data.hasOwnProperty('all') && data.all === true) {
            return this.$http.get(this.URLS.FETCH + '/instructors?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        if (data && (data.hasOwnProperty('page') ||
            data.hasOwnProperty('name') ||
            data.hasOwnProperty('status'))) {
            return this.$http.get(this.URLS.FETCH + '/instructors?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/instructors').then(this.cacheUsers);
    };
    /*
     * Used to get list of instructors with just name and id, no zoneparts/location/other extra data
     *
     * @deprecated
     */
    UsersModel.prototype.listInstructors = function () {
        return this.$http.get(this.URLS.FETCH + '/instructors/list').then(this.cacheUsers);
    };
    UsersModel.prototype.createInstructor = function (user) {
        return this.$http.post(this.URLS.CREATE + '/instructors', user).then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorLocations = function (id) {
        return this.$http.get(this.URLS.FETCH + '/instructors/' + id + '/locations').then(this.cacheUsers);
    };
    UsersModel.prototype.addInstructorLocation = function (data) {
        return this.$http.post(this.URLS.CREATE + '/instructors/addlocation', data).then(this.cacheUsers);
    };
    UsersModel.prototype.editInstructorLocation = function (data) {
        return this.$http.put(this.URLS.CREATE + '/instructors/editlocation', data).then(this.cacheUsers);
    };
    UsersModel.prototype.unattachInstructorLocation = function (data) {
        return this.$http.post(this.URLS.CREATE + '/instructors/removelocation', data).then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorTimeOffRequests = function (data) {
        if (data && data.hasOwnProperty('page')) {
            return this.$http.get(this.URLS.FETCH + '/instructors/' + data.id + '/timeoffrequests?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.CREATE + '/instructors/' + data.id + '/timeoffrequests').then(this.cacheUsers);
    };
    UsersModel.prototype.searchInstructors = function (data) {
        return this.$http.post(this.URLS.CREATE + '/instructors/search', data).then(this.cacheUsers);
    };
    UsersModel.prototype.editInstructorLocations = function (data) {
        return this.$http.put(this.URLS.CREATE + '/instructors/locations/' + data.id, data).then(this.cacheUsers);
    };
    UsersModel.prototype.updateInstructor = function (user) {
        return this.$http.put(this.URLS.FETCH + '/instructors/' + user.id, user).then(this.cacheUsers);
    };
    UsersModel.prototype.updateInstructorAvailability = function (id, data) {
        return this.$http.put(this.URLS.FETCH + '/instructors/' + id + '/availability', data).then(this.cacheUsers);
    };
    UsersModel.prototype.deleteInstructor = function (user) {
        return this.$http.delete(this.URLS.FETCH + '/instructors/' + user.id).then(this.cacheUsers);
    };
    UsersModel.prototype.disableInstructor = function (user) {
        return this.$http.post(this.URLS.FETCH + '/instructors/disable', user).then(this.cacheUsers);
    };
    UsersModel.prototype.activateInstructor = function (user) {
        return this.$http.post(this.URLS.FETCH + '/instructors/activate', user).then(this.cacheUsers);
    };
    UsersModel.prototype.getNextInstructorEntity = function (data) {
        return this.$http.get(this.URLS.FETCH + '/instructors/' + data.id + '/nextentity').then(this.cacheUsers);
    };
    UsersModel.prototype.getInstructorSchedulingHistory = function (id, data) {
        return this.$http.post(this.URLS.FETCH + '/instructors/' + id + '/scheduling-history', data).then(this.cacheUsers);
    };
    /**
     * Student specific model data
     */
    UsersModel.prototype.sendWelcomeEmail = function (id) {
        return this.$http.post(this.URLS.CREATE + '/students/' + id + '/welcome-email', {}).then(this.cacheUsers);
    };
    UsersModel.prototype.sendInstructorWelcomeEmail = function (id) {
        return this.$http.post(this.URLS.CREATE + '/instructors/' + id + '/welcome-email', {}).then(this.cacheUsers);
    };
    UsersModel.prototype.sendStaffWelcomeEmail = function (id) {
        return this.$http.post(this.URLS.CREATE + '/staff/' + id + '/welcome-email', {}).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentBalance = function (id) {
        return this.$http.get(this.URLS.CREATE + '/students/' + id + '/balance').then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentUsageDetails = function (id) {
        return this.$http.get(this.URLS.CREATE + '/students/' + id + '/usage-details').then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentOrders = function (data) {
        return this.$http.get("".concat(this.URLS.CREATE, "/students/").concat(data.student_id, "/orders?").concat((0, queryString_1.toQueryString)(data))).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentCourseDetails = function (id) {
        return this.$http.get(this.URLS.CREATE + '/students/' + id + '/course-details').then(this.cacheUsers);
    };
    UsersModel.prototype.createStudent = function (user) {
        return this.$http.post(this.URLS.CREATE + '/students', user).then(this.cacheUsers);
    };
    UsersModel.prototype.adminCreateStudent = function (user) {
        return this.$http.post(this.URLS.CREATE + '/students/create', user).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentCancellationRules = function (DriveID, studentId) {
        if (studentId === void 0) { studentId = null; }
        if (studentId !== null) {
            return this.$http.get(this.URLS.CREATE + '/students/drives/cancellation-rules/' + DriveID + '?' + (0, queryString_1.toQueryString)({ student_id: studentId })).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.CREATE + '/students/drives/cancellation-rules/' + DriveID).then(this.cacheUsers);
    };
    /**
     * Get a list of the students drives
     *
     * @deprecated
     */
    UsersModel.prototype.getStudentDrives = function (data) {
        if (data) {
            var url = this.URLS.FETCH + '/students/' + data.id + '/drives?' + (0, queryString_1.toQueryString)(data);
            return this.$http.get(url).then(this.cacheResponse);
        }
        return this.$http.get(this.URLS.FETCH + '/students/' + data.id + '/drives').then(this.cacheResponse);
    };
    UsersModel.prototype.scheduleClassDate = function (student_id, course_id, class_id) {
        return this.$http.post(this.URLS.FETCH + '/students/' + student_id + '/book-class', { course_id: course_id, class_id: class_id }).then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentAvailableClasses = function (id, data) {
        if (data) {
            return this.$http.get(this.URLS.FETCH + '/students/' + id + '/available-classes?' + (0, queryString_1.toQueryString)(data)).then(this.cacheResponse);
        }
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/available-classes').then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentClasses = function (student_id, data) {
        if (data !== null) {
            return this.$http.get(this.URLS.FETCH + '/students/' + student_id + '/classes?' + (0, queryString_1.toQueryString)(data)).then(this.cacheResponse);
        }
        return this.$http.get(this.URLS.FETCH + '/students/' + student_id + '/classes').then(this.cacheResponse);
    };
    UsersModel.prototype.cancelStudentClass = function (student_id, class_id) {
        return this.$http.post(this.URLS.FETCH + '/students/' + student_id + '/classes/' + class_id + '/cancel', null).then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentUpcomingClasses = function (data) {
        return this.$http.get(this.URLS.FETCH + '/students/' + data.id + '/upcoming-classes').then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentPastClasses = function (data) {
        return this.$http.get(this.URLS.FETCH + '/students/' + data.id + '/past-classes').then(this.cacheResponse);
    };
    UsersModel.prototype.getReportcardForDrive = function (data) {
        return this.$http.get("".concat(this.URLS.FETCH, "/students/").concat(data.student_id, "/drive/").concat(data.drive_id, "/reportcard")).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentReportcards = function (data) {
        var id = data.id;
        var requestBody = Object.assign({}, data);
        delete requestBody.id;
        if (requestBody) {
            var url = this.URLS.FETCH + '/students/' + id + '/reportcards?' + (0, queryString_1.toQueryString)(requestBody);
            return this.$http.get(url).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/reportcards').then(this.cacheUsers);
    };
    UsersModel.prototype.printStudentReportcards = function (data) {
        return this.$http.get(this.URLS.FETCH + '/students/' + data.id + '/reportcards/print').then(this.cacheUsers);
    };
    UsersModel.prototype.printStudentAccount = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/print').then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentCart = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/cart').then(this.cacheUsers);
    };
    UsersModel.prototype.setStudentCart = function (id, data) {
        return this.$http.put(this.URLS.FETCH + '/students/' + id + '/cart', data).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentPaymentSetupIntent = function (id, mode, amount) {
        if (mode === void 0) { mode = 'setup'; }
        if (amount === void 0) { amount = 0; }
        if (mode === 'setup') {
            return this.$http.get("".concat(this.URLS.FETCH, "/students/").concat(id, "/payment-setup-intent?mode=setup")).then(this.cacheUsers);
        }
        return this.$http.get("".concat(this.URLS.FETCH, "/students/").concat(id, "/payment-setup-intent?mode=payment&amount=").concat(amount)).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentPaymentMethods = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/payment-methods').then(this.cacheUsers);
    };
    UsersModel.prototype.addStudentPaymentMethod = function (id, data) {
        return this.$http.post(this.URLS.FETCH + '/students/' + id + '/payment-methods', data).then(this.cacheUsers);
    };
    UsersModel.prototype.removeStudentPaymentMethod = function (student_id, payment_method_id) {
        return this.$http.delete(this.URLS.FETCH + '/students/' + student_id + '/payment-methods/' + payment_method_id).then(this.cacheUsers);
    };
    UsersModel.prototype.getFiles = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/files').then(this.cacheUsers);
    };
    UsersModel.prototype.updateStudentDrivePickupLocation = function (drive) {
        drive['currentTime'] = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
        return this.$http.put(this.URLS.FETCH + '/students/drives/pickuplocation/' + drive.id, drive).then(this.cacheUsers);
    };
    UsersModel.prototype.updatePickUpLocation = function (student_id, pick_up_location_id, data) {
        return this.$http.put(this.URLS.FETCH + '/students/' + student_id + '/pickuplocations/' + pick_up_location_id, data)
            .then(this.cacheUsers);
    };
    UsersModel.prototype.getPickupLocations = function (id) {
        return this.$http.get("".concat(this.URLS.FETCH, "/students/").concat(id, "/pickuplocations")).then(this.cacheUsers);
    };
    UsersModel.prototype.completeStudentSetup = function (id, data) {
        return this.$http.post("".concat(this.URLS.FETCH, "/students/").concat(id, "/complete-setup"), data).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentByID = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id).then(this.cacheUser);
    };
    UsersModel.prototype.getPurchasedTime = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/purchased-time').then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentFees = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/fees').then(this.cacheResponse);
    };
    UsersModel.prototype.getStudentFeePayments = function (student_id, fee_id) {
        return this.$http.get("".concat(this.URLS.FETCH, "/students/").concat(student_id, "/fees/").concat(fee_id, "/payments")).then(this.cacheResponse);
    };
    UsersModel.prototype.validateFeeForm = function (data) {
        var student_id = data.student_id;
        var fee_id = data.fee_id;
        var payload = data.data;
        return this.$http.post("".concat(this.URLS.FETCH, "/students/").concat(student_id, "/fees/").concat(fee_id, "/payments/validate"), payload).then(this.cacheResponse);
    };
    UsersModel.prototype.getNextStudentEntity = function (data) {
        return this.$http.get(this.URLS.FETCH + '/students/' + data.id + '/nextentity').then(this.cacheUsers);
    };
    UsersModel.prototype.voidFee = function (student_id, fee_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/students/").concat(student_id, "/fees/").concat(fee_id, "/void"), {}).then(this.cacheResponse);
    };
    UsersModel.prototype.markStudentFeePaid = function (studentId, feeId) {
        return this.$http.put(this.URLS.FETCH + '/students/' + studentId + '/fees', {
            'feeId': feeId,
            'flag': 'paid'
        }).then(this.cacheResponse);
    };
    UsersModel.prototype.submitPayment = function (student_id, fee_id, payment) {
        return this.$http.post("".concat(this.URLS.FETCH, "/students/").concat(student_id, "/fees/").concat(fee_id, "/payments"), payment).then(this.cacheResponse);
    };
    UsersModel.prototype.voidPayment = function (student_id, payment_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/students/").concat(student_id, "/payments/").concat(payment_id, "/void"), {}).then(this.cacheResponse);
    };
    UsersModel.prototype.addStudentFee = function (data) {
        return this.$http.post(this.URLS.FETCH + '/students/' + data.id + '/fees', data).then(this.cacheResponse);
    };
    UsersModel.prototype.getStudents = function (data) {
        if (data) {
            return this.$http.get(this.URLS.FETCH + '/students?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/students').then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentAgenda = function (data) {
        return this.$http.post(this.URLS.CREATE + '/students/agenda', data).then(this.cacheUsers);
    };
    UsersModel.prototype.searchStudents = function (data) {
        return this.$http.post(this.URLS.CREATE + '/students/search', data).then(this.cacheUsers);
    };
    UsersModel.prototype.searchStudentsByName = function (data) {
        return this.$http.post(this.URLS.CREATE + '/students/searchbyname', data).then(this.cacheUsers);
    };
    UsersModel.prototype.unattachStudentPickupLocation = function (student_id, pickup_location_id) {
        return this.$http.delete(this.URLS.CREATE + '/students/' + student_id + '/pickuplocations/' + pickup_location_id).then(this.cacheUsers);
    };
    UsersModel.prototype.resetPickupLocationInServiceArea = function (student_id) {
        return this.$http.post(this.URLS.CREATE + '/students/' + student_id + '/pickuplocations/reset', {}).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentPickupLocationsByDriveSession = function (drive_id) {
        return this.$http.get(this.URLS.CREATE + '/students/pickuplocations/drive/' + drive_id).then(this.cacheUsers);
    };
    UsersModel.prototype.updateStudent = function (user) {
        return this.$http.put(this.URLS.FETCH + '/students/' + user.id, user).then(this.cacheUsers);
    };
    UsersModel.prototype.getDriveDeadline = function (student_id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + student_id).then(this.cacheUsers);
    };
    UsersModel.prototype.updateDriveDeadline = function (student_id, data) {
        return this.$http.put(this.URLS.FETCH + '/students/' + student_id + '/drive-deadline', data).then(this.cacheUsers);
    };
    UsersModel.prototype.addPickupLocation = function (data) {
        return this.$http.post(this.URLS.FETCH + '/students/pickuplocations', data).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentInstructors = function (student_id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + student_id + '/instructors').then(this.cacheUsers);
    };
    UsersModel.prototype.addInstructorToStudent = function (student_id, data) {
        return this.$http.post(this.URLS.FETCH + '/students/' + student_id + '/instructors', data).then(this.cacheUsers);
    };
    UsersModel.prototype.removeInstructorFromStudent = function (student_id, instructor_id) {
        return this.$http.delete(this.URLS.FETCH + '/students/' + student_id + '/instructors/' + instructor_id).then(this.cacheUsers);
    };
    UsersModel.prototype.addZone = function (user_id, zone_id) {
        return this.$http.put(this.URLS.FETCH + '/students/' + user_id + '/zones/' + zone_id, {}).then(this.cacheUsers);
    };
    UsersModel.prototype.placePickupLocation = function (data) {
        return this.$http.post(this.URLS.FETCH + '/students/pickuplocations/place', data).then(this.cacheUsers);
    };
    UsersModel.prototype.verifyStudent = function (data) {
        return this.$http.post(this.URLS.FETCH + '/students/verify', data).then(this.cacheUsers);
    };
    UsersModel.prototype.deleteStudent = function (user) {
        return this.$http.delete(this.URLS.FETCH + '/students/' + user.id).then(this.cacheUsers);
    };
    UsersModel.prototype.archiveStudent = function (id) {
        return this.$http.post(this.URLS.FETCH + '/students/archive', { 'id': id }).then(this.cacheUsers);
    };
    UsersModel.prototype.activateStudent = function (id) {
        return this.$http.post(this.URLS.FETCH + '/students/activate', { 'id': id }).then(this.cacheUsers);
    };
    UsersModel.prototype.deactivateStudent = function (id) {
        return this.$http.post(this.URLS.FETCH + '/students/deactivate', { 'id': id }).then(this.cacheUsers);
    };
    UsersModel.prototype.updateStudentSettings = function (user) {
        return this.$http.put(this.URLS.FETCH + '/students/update/settings/' + user.id, user).then(this.cacheUsers);
    };
    UsersModel.prototype.requirements = function (id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/lesson-plan-requirements').then(this.cacheUsers);
    };
    UsersModel.prototype.addRequirement = function (id, data) {
        return this.$http.post(this.URLS.FETCH + '/students/' + id + '/lesson-plan-requirements', data).then(this.cacheUsers);
    };
    UsersModel.prototype.updateRequirement = function (id, data) {
        return this.$http.put(this.URLS.FETCH + '/students/' + id + '/lesson-plan-requirements', data).then(this.cacheUsers);
    };
    UsersModel.prototype.removeRequirement = function (student_id, requirement_id) {
        return this.$http.delete(this.URLS.FETCH + '/students/' + student_id + '/lesson-plan-requirements/' + requirement_id).then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentNotes = function (id, data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http.get(this.URLS.FETCH + '/students/' + id + '/notes?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/notes').then(this.cacheUsers);
    };
    UsersModel.prototype.getStudentNote = function (id, note_id) {
        return this.$http.get(this.URLS.FETCH + '/students/' + id + '/notes/' + note_id).then(this.cacheUsers);
    };
    UsersModel.prototype.editStudentNote = function (id, note_id, data) {
        return this.$http.put(this.URLS.FETCH + '/students/' + id + '/notes/' + note_id, data).then(this.cacheUsers);
    };
    UsersModel.prototype.addStudentNote = function (id, data) {
        return this.$http.post(this.URLS.FETCH + '/students/' + id + '/notes', data).then(this.cacheUsers);
    };
    UsersModel.prototype.removeStudentNote = function (student_id, note_id) {
        return this.$http.delete(this.URLS.FETCH + '/students/' + student_id + '/notes/' + note_id).then(this.cacheUsers);
    };
    /**
     * Staff specific modal data
     */
    UsersModel.prototype.createStaff = function (user) {
        return this.$http.post(this.URLS.CREATE + '/staff', user).then(this.cacheUsers);
    };
    UsersModel.prototype.getStaff = function (data) {
        if (data) {
            return this.$http.get(this.URLS.FETCH + '/staff?' + (0, queryString_1.toQueryString)(data)).then(this.cacheUsers);
        }
        return this.$http.get(this.URLS.FETCH + '/staff').then(this.cacheUsers);
    };
    UsersModel.prototype.updateStaff = function (user) {
        return this.$http.put(this.URLS.FETCH + '/staff/' + user.id, user).then(this.cacheUsers);
    };
    /**
     * Owner specific model stuff
     */
    UsersModel.prototype.switchToSchool = function (schoolID) {
        return this.$http.patch(this.URLS.FETCH + '/owners/switch-to-school', { 'school_id': schoolID }).then(this.cacheUsers);
    };
    return UsersModel;
}());
UsersModel.$inject = ['$http', 'UserService', 'APPURL'];
exports.default = UsersModel;
